import { useEffect, useState } from 'react';
import type { SubmitHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Dialog } from '#pie/components/layout/dialog/Dialog';
import { useCreateContact } from '#pie/hooks/useCreateContact';
import type { CreateContactRequest } from '#pie/internal/api/pie-bff';
import { ContactForm } from './ContactForm';

interface CreateCprContactModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  contactGroupId: string;
  onFlowBack?: () => void;
}

export const CreateCprContactModal = ({
  open,
  onOpenChange,
  contactGroupId,
  onFlowBack,
}: CreateCprContactModalProps) => {
  const { t } = useTranslation();

  const { mutate, isPending } = useCreateContact({
    onSuccess: () => onOpenChange(false),
  });

  const onSubmit: SubmitHandler<CreateContactRequest> = (data) => {
    mutate({ data });
  };

  const [step, setStep] = useState(1);

  useEffect(() => {
    if (!open) return;
    setStep(1);
  }, [open]);

  const stepDescriptions: Record<number, string> = {
    1: t('cpr_management.contact_modal.step.personal_data'),
    2: t('cpr_management.contact_modal.step.contact_groups'),
  };

  return (
    <Dialog
      title={t('cpr_management.contact_modal.title.create')}
      size="md"
      open={open}
      onOpenChange={onOpenChange}
      description={stepDescriptions[step]}
    >
      <ContactForm
        step={step}
        onNext={() => setStep(2)}
        onBack={() => setStep(1)}
        onFlowBack={
          onFlowBack
            ? () => {
                onOpenChange(false);
                onFlowBack();
              }
            : undefined
        }
        defaultValues={{ contactGroups: [contactGroupId] }}
        isLoading={isPending}
        onSubmit={onSubmit}
        submitText={t(
          'cpr_contact_group_detail.create_user.modal.button.create',
        )}
      />
    </Dialog>
  );
};
